import { gql } from '@apollo/client';

export const UNIT_FIELDS = gql`
  fragment UnitFields on Unit {
    id
    code
    name
    status
    created_at
    updated_at
  }
`;

export const UNITS_QUERY = gql`
  ${UNIT_FIELDS}
  query Units(
    $offset: Int
    $limit: Int
    $search: String
    $status_filter: CatalogStatusFilter
  ) {
    units(offset: $offset, limit: $limit, search: $search, status_filter: $status_filter) {
      items {
        ...UnitFields
      }
      page {
        total
        offset
        limit
        has_more
      }
    }
  }
`;

export const CREATE_UNIT_MUTATION = gql`
  ${UNIT_FIELDS}
  mutation CreateUnit($input: CreateUnitInput!) {
    createUnit(input: $input) {
      ...UnitFields
    }
  }
`;

export const UPDATE_UNIT_MUTATION = gql`
  ${UNIT_FIELDS}
  mutation UpdateUnit($id: ID!, $input: UpdateUnitInput!) {
    updateUnit(id: $id, input: $input) {
      ...UnitFields
    }
  }
`;

export const SET_UNIT_STATUS_MUTATION = gql`
  ${UNIT_FIELDS}
  mutation SetUnitStatus($id: ID!, $status: String!) {
    setUnitStatus(id: $id, status: $status) {
      ...UnitFields
    }
  }
`;
